import { UiControl } from './ui-control.model';
import { BaseControlOption } from '../control-options/control-option.interface';

export class PasswordControl extends UiControl<string> {

  confirmPasswordFieldId: string;
  performValidation: boolean;

  constructor(id: string, label: string, value: string, performValidation: boolean, confirmPasswordFieldId: string, ...options: BaseControlOption[]) {
    super(id, label, value, false, options);
    this.performValidation = performValidation;
    this.confirmPasswordFieldId = confirmPasswordFieldId;
    this.className = "PasswordControl";
  }

}
